import {  
    getFirestore,
    doc,
    setDoc
} from "firebase/firestore";
const setGroupData = async function(data, groupId) {

    let db = getFirestore();
    let ref = doc(db, '/wellness_groups/' + groupId);
    await setDoc(ref, data, {merge: true} );
    console.log(ref);
    return ref;
};
export default setGroupData;